module.exports = __webpack_public_path__ + "img/close-pos.c7fc099a.svg";